import React from "react";
import { FunctionField, useRecordContext } from "react-admin";
import { custInfo } from "./customer";

function _formatNum(value: number, dp: number): string {
  return Number(value.toFixed(dp)).toLocaleString();
}

const litrePerUSG = 3.78541178;

function ConvertLitreToGal(value: number): number {
  return value / litrePerUSG;
}
function ConvertGalToLitre(value: number): number {
  return value * litrePerUSG;
}

const VolumeField = ({
  source,
  label,
  precision = 0,
}: {
  source: string;
  label?: string;
  precision?: number;
}) => {
  const record = useRecordContext();
  const value = record[source];
  if (!value) return <FunctionField render={() => "\u00A0"} />;

  const unit = custInfo.customerPreferences.volumeUnit;
  let renderText: string;

  if (unit && unit === "Gal") {
    renderText = _formatNum(ConvertLitreToGal(value), precision) + " Gal";
  } else {
    renderText = _formatNum(value, precision) + " L";
  }

  return <FunctionField render={() => `${renderText}`} />;
};

export { VolumeField, ConvertGalToLitre, ConvertLitreToGal, _formatNum };
